import styles from './BootSplash.module.css';

/**
 * Brief full-screen splash shown only while the boot-time silent refresh
 * resolves (useBootstrapAuth). Prevents a Login flash for a driver whose
 * 30-day refresh cookie is still valid but whose localStorage was evicted
 * (iOS Safari ITP / storage pressure). A live localStorage session never
 * reaches this — it skips the splash entirely.
 */
export function BootSplash() {
  return (
    <div className={styles.splash} role="status" aria-label="Restoring your session">
      <span className={styles.spinner} aria-hidden />
    </div>
  );
}
